// Convite ao app Minha Escala na tela pós-envio do formulário (D24/D32).
// URLs das lojas e QR vêm do build (REACT_APP_ME_APP_*); vazio = null e, sem loja, o cartão se esconde (P14).
export type AppInviteConfig = {
  iosUrl: string | null;
  androidUrl: string | null;
  qrSrc: string | null;
};

const clean = (v: string | undefined): string | null => (v && v.trim() ? v.trim() : null);

export const readAppInvite = (env: Record<string, string | undefined>): AppInviteConfig => ({
  iosUrl: clean(env.REACT_APP_ME_APP_IOS_URL),
  androidUrl: clean(env.REACT_APP_ME_APP_ANDROID_URL),
  qrSrc: clean(env.REACT_APP_ME_APP_QR_SRC),
});

export const APP_INVITE: AppInviteConfig = readAppInvite(process.env as Record<string, string | undefined>);

/**
 * `channel` da resposta do POST /doctor/request (BE-1f): `form` (formulário público) ou `minha_escala`
 * (outbox do ME). Só quem pediu pelo formulário é convidado; sem o campo (BE antigo) também convida,
 * porque o formulário público nunca manda token do ME.
 */
export const shouldInviteToApp = (channel: string | null | undefined): boolean => channel == null || channel === "form";
